const DK = {
  associationIncorporated: [
    "forening med begrænset ansvar",
    "forening med begrænset ansvar (FMBA)",
    "andelsselskab med begrænset ansvar (AMBA)"
  ],
  partnershipIncorporated: [
    "partnerselskab (P/S)",
    "kommanditselskab (K/S)"
  ],
  partnershipUnincorporated: [
    "interessentskab (I/S)"
  ]
};
export {
  DK as default
};
